var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-component"},[_c('div',{staticClass:"gallery-container"},[_c('agile',_vm._l((_vm.list),function(l,i){return _c('div',{key:i,staticClass:"slide"},[_c('img',{attrs:{"src":l.img.src,"alt":l.img.alt}})])}),0)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }